// 每日排线结果 & 司机指派  - 列表
export const API_POST_ADAPTATION_CARRIER_SELECT_PAGE_INFO = {
  url: 'api/tms/adaptation/carrier/select/page/info',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 每日排线结果 & 司机指派  - 数量
export const API_POST_ADAPTATION_CARRIER_SELECT_ROUTE_COUNT = {
  url: 'api/tms/adaptation/carrier/select/route/count',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 每日排线结果 & 司机指派  - 批量确认
export const API_POST_ADAPTATION_CARRIER_BATCH_CONFIRAMSTION = {
  url: 'api/tms/adaptation/carrier/batch/confirmation',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 每日排线结果 & 司机指派  - 批量拒绝
export const API_POST_ADAPTATION_CARRIER_BATCH_REJECT = {
  url: 'api/tms/adaptation/carrier/batch/reject',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 每日排线结果 & 司机指派  - 更改司机
export const API_POST_ADAPTATION_CARRIER_UPDATE_DRIVER = {
  url: 'api/tms/adaptation/route/carrier/update/driver',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
// 每日排线结果&司机指派列表  点击 预计总金额 查询商品明细
export const API_POST_ADAPTATION_CARRIER_QUERY_GOODS_DETAIL = {
  url: 'api/tms/adaptation/carrier/queryGoodsDetail',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
// 每日排线结果&司机指派列表  查看详情 点击 预计总金额 查询商品明细
export const API_POST_ADAPTATION_CARRIER_ROUTEDETAILQUERYGOODSDETAIL = {
  url: 'api/tms/adaptation/carrier/routeDetailQuerygoodsdetail',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 每日排线结果 & 司机指派  - 查询司机
export const API_POST_ADAPTATION_CARRIER_SELECT_DRIVER = {
  url: 'api/tms/adaptation/route/carrier/select/driver',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 每日排线结果 & 司机指派  - 明细查看
export const API_POST_ADAPTATION_CARRIER_SELECT_ROUTE_BY_ID = {
  url: 'api/tms/adaptation/route/carrier/select/route/by/Id',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 查询承运商下仓库
export const API_POST_QUERY_SUPPLIER_WAREHOUSE_CODE = {
  url: '/api/tms/query/supplier/warehouse/code',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};
